// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"763c8cee","120":"8f56a083","192":"389307de","214":"64fa1bd0","460":"b945f4b2","483":"06172569","546":"81a29870","637":"bcd8a161","674":"304cd722","687":"ca1440bb","796":"c08fefd7","914":"42d55cf9","954":"dea5d8c8","990":"b66adc28","994":"5431fe3e"}[chunkId] + ".chunk.js";
};